import { RESOURCES_CONSTANTS } from "config/constants";

const { SPACE_TYPES_IDS } = RESOURCES_CONSTANTS;

export const SPACE_TYPES_WITH_UNIQUE_ACTIVITY = [SPACE_TYPES_IDS.FIELD];

export const FORM_FIELD_KEYS = {
    ID: "id",
    CAMPUS_ID: "campusId",
    SPACE_TYPE_ID: "spaceTypeId",
    NAME: "name",
    AVAILABLE_ACTIVITY_IDS: "availableActivityIds",
    MIN_CAPACITY: "minCapacity",
    MAX_CAPACITY: "maxCapacity",
    ADDRESS: "address",
    REFERENCE: "reference",
    SPACE_OUT_OF_CAMPUS: "spaceOutOfCampus",
    DETAILS: "details",
    ACTIVE: "active"
};
export const INIT_SPACE_FORM = {
    [FORM_FIELD_KEYS.ID]: 0, 
    [FORM_FIELD_KEYS.CAMPUS_ID]: 0,
    [FORM_FIELD_KEYS.SPACE_TYPE_ID]: 0,
    [FORM_FIELD_KEYS.NAME]: "",
    [FORM_FIELD_KEYS.AVAILABLE_ACTIVITY_IDS]: [],
    [FORM_FIELD_KEYS.MIN_CAPACITY]: "",
    [FORM_FIELD_KEYS.MAX_CAPACITY]: "",
    [FORM_FIELD_KEYS.ADDRESS]: "",
    [FORM_FIELD_KEYS.REFERENCE]: "",
    [FORM_FIELD_KEYS.SPACE_OUT_OF_CAMPUS]: false,
    [FORM_FIELD_KEYS.DETAILS]: "",
    [FORM_FIELD_KEYS.ACTIVE]: true
};
export const INIT_SPACE_FORM_ERRORS = {
    capacityRange: false
};
export const MAX_LENGTH_FORM = {
    name: 50,
    address: 80,
    reference: 80,
    minCapacity: 2,
    maxCapacity: 2,
    details: 300
};
export const FORM_ACTION_ERRORS_BEFORE_REQUEST = {
    CAPACITY_RANGE_IS_INVALID: "CAPACITY_RANGE_IS_INVALID"
};
export const TEXT_LIST_BY_FORM_ACTION_ERRORS = {
    CAPACITY_RANGE: "El aforo máximo debe ser mayor o igual al mínimo."
}
export const FORM_ACTION_ERRORS = {
    FUTURE_RESERVATIONS: "RESERVAS_FUTURAS"
};